import React from "react";
import { FormattedMessage } from "react-intl";
import { RoleEnum } from "../types/RoleEnum";
import { ROUTE_PATHS } from "../types/routePaths";
export var navigation = {
    titlesWithIsbn: {
        path: ROUTE_PATHS.TITLES_WITH_ISBN,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.titles-with-isbn" })),
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    titlesWithoutIsbn: {
        path: ROUTE_PATHS.TITLES_WITHOUT_ISBN,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.titles-without-isbn" })),
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    periodicalsManagement: {
        path: ROUTE_PATHS.PERIODICALS,
        label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.periodicals" }),
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    titlesForVerification: {
        path: ROUTE_PATHS.TITLES_VERIFICATION,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.titles-verification" })),
        sectionStart: true,
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    periodicalsForVerification: {
        path: ROUTE_PATHS.PERIODICALS_VERIFICATION,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.periodicals-verification" })),
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    frequencyConflicts: {
        path: ROUTE_PATHS.FREQUENCY_CONFLICTS,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.frequency-conflicts" })),
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    newPeriodicals: {
        path: ROUTE_PATHS.NEW_PERIODICALS,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.new-periodicals" })),
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    periodicalChecks: {
        path: ROUTE_PATHS.PERIODICAL_CHECKS,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.periodical-checks" })),
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    requestableTitles: {
        path: ROUTE_PATHS.REQUESTABLE_TITLES,
        label: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.requestable-titles" })),
        sectionStart: true,
        roles: [
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
        ],
    },
    publishers: {
        path: ROUTE_PATHS.PUBLISHERS,
        label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.publishers" }),
    },
    libraries: {
        path: ROUTE_PATHS.LIBRARIES,
        label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.libraries" }),
        roles: [RoleEnum.ADMIN_LEGAL_DEPOSITS],
    },
    userManagement: {
        path: ROUTE_PATHS.USERS,
        label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.users" }),
        roles: [RoleEnum.ADMIN_LEGAL_DEPOSITS],
    },
    outputs: {
        path: ROUTE_PATHS.OUTPUTS,
        label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.outputs" }),
        roles: [
            RoleEnum.ADMIN_LEGAL_DEPOSITS,
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS,
            RoleEnum.LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS,
        ],
    },
    admin: {
        path: ROUTE_PATHS.ADMIN,
        label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.navigation.admin" }),
        roles: [RoleEnum.SUPERUSER],
    },
};
